import type { ReactNode } from 'react'

import type { TPublicationApi } from '../../../api/types/getPublication.types'
import { usePublicationQuery } from '../../../services/usePublicationQuery'

type TPublicationSeedProps<T> = {
  initialPublicationId: number
  initialPublication?: T
  children: (result: ReturnType<typeof usePublicationQuery>) => ReactNode
}

export const PublicationSeed = <T extends TPublicationApi>({
  initialPublicationId,
  initialPublication,
  children,
}: TPublicationSeedProps<T>) => {
  const result = usePublicationQuery(initialPublicationId, initialPublication, initialPublication?.published)
  return children(result)
}
